/**
 * Controls for the painted door "work in progress" view.
 */
import type { ActionContext } from 'js/lib/ActionContext';

import { EVENT_NAMES } from '../constants';

/**
 * Show/hide the painted door.
 */
export const show = (
  /** Provided by fluxible. */
  actionContext: ActionContext,
  /** Request that the painted door be shown or hidden, or toggled if not passed. */
  value?: boolean
): void => {
  const { show: existingValue } = actionContext.getStore('StaffManagementStoreV2').ui('paintedDoor');
  // Toggle existing value if show is not passed in as argument.
  actionContext.dispatch(EVENT_NAMES.UI, { paintedDoor: { show: value === undefined ? !existingValue : value } });
};
